/**
 * 创建人：zll
 * 时间：2020-9-28
 * 描述：时间线组件
 * 使用说明: 参考 sw-timeline 配置应用说明文档 
 * 更新记录: 
 * 
 */
import { Input,Component, OnInit, HostListener, ElementRef,Output, EventEmitter, ContentChild, TemplateRef } from '@angular/core';
declare var $:any;

/**
 * 自选表单字段右移动组件   sw-timeline
 */
@Component({
  selector: 'sw-timeline',
  templateUrl: './sw-timeline.component.html',
  styleUrls: ['./sw-timeline.component.css']
})
export class SwTimelineComponent implements OnInit {
 
  /**
   * 案例：
   * [
   * {id:"1",icon:"icon iconfont iconbtn_message",type:"bg-blue",createTime:'2020-09-28',detailCreateTime:'2020-09-28',detailTime:"12:05:03",title:{titleName:"小团队",titleContent:"发送邮件"},content:"我是内容",footer:'我是底部'},
   * ]
   * icon: 为图标class  
   * type:图标类型  bg-blue bg-gray  bg-gray-light bg-black bg-red bg-yellow bg-aqua bg-blue bg-light-blue bg-green bg-navy bg-teal bg-olive bg-lime bg-orange bg-fuchsia bg-purple bg-maroon
   * createTime: 创建时间  
   * detailTime: 具体时间 可以为空 前端操作 （可以没有该字段）
   * title 格式不限 可以为空 前端操作 （可以没有该字段）
   * content 格式不限 可以为空 前端操作（可以没有该字段）
   * footer 格式不限 可以为空 前端操作（可以没有该字段）
   * 点击的标题
   * @ignore 
   */
  @Input() datas:any =[] 

   /**
   * 时间线是否有图标 true为有图标 false为没有图标为默认样式
   * @ignore 
   */
  @Input() isHasIcon: boolean = false; 
   /** 
   * layout 时间线内容布局： 1代表上下布局； 2代表左右布局; 3代表时间栏和内容栏都可自定义 4.代表时间栏、内容栏、时间线左侧栏都可自定义
   * @ignore 
   */
  @Input() layout: any = '1'; 
   /**
   * layout内容布局为4时  可设置 时间线左侧栏内容宽度
   * @ignore 
   */
  @Input() leftWidth: any = '50'; 
  /**
   * layout内容布局为2时  可设置其标题的宽度
   * @ignore 
   */
  @Input() width: any = '110'; 


  rightWidth:any = ''
  leftWidthCha:number = 0
  /**
   * 显示数据 
   * @ignore
   */
  @ContentChild('line') lineTmpl: TemplateRef<any>;
  @ContentChild('time') timeTmpl: TemplateRef<any>;
  @ContentChild('leftLine') leftLineTmpl: TemplateRef<any>;
  /**
   * @ignore
   */
  constructor(private _elementRef: ElementRef) { }

  /**
   * @ignore
   */
  ngOnInit() {
     this.rightWidth = (this.width-0)+ 90 +'px'
     this.leftWidthCha = this.leftWidth - 20
  }
 
  /**
   * @ignore
   */
  ngAfterViewInit(){
    
  }
  
 
}
